import { createTileLayer } from '@/map'

export function createLocationEditorTileLayer(tile: uui.domain.ui.map.MapTile, lng: string) {
  return createTileLayer({
    tileType: tile,
    tileSize: 256,
    lng,
  })
}
